import { Endpoint } from '@eryxcoop/appyx-comm';

export default class UpdateAuthorizationsEndpoint extends Endpoint {

  adaptValues(values) {
    const authorizationsId = values['authorizations_ids']
    return {
      authorizations_ids: authorizationsId.map(authorizationId => (authorizationId)),
      state: values['state'],
      observations: values['observations'],
    };
  }
}
